import PrinterFaultyDotsModal from './printer-faulty-dots-modal.connect'

export default PrinterFaultyDotsModal
